export default "__VITE_ASSET__BK1F5ENF__"